
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericFastOutlined as ObiVesselGenericFastOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-fast-outlined.js';
 
 
 

 
 export const ObiVesselGenericFastOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-fast-outlined',
   elementClass: ObiVesselGenericFastOutlinedElement,
   events: {
     
   }
  });
 
 